<nav [@animateMenu] class="navbar main-navbar on-top" [class.nav-shadow]='this.pageYPosition>0'>
    <div class="container">
        <a class="navbar-brand text-light" [routerLink]="'/'">
            <img src='assets/icons/android-chrome-192x192.png' width="50" alt="Burak Güngör Logo"/>
        </a>
        <ul ngbNav #nav="ngbNav" class="menu-ul">
            <li ngbNavItem>
                <a ngbNavLink (click)='scroll("about")'><span class="underline nav-text"> {{"Header.Item1" | translate}}</span></a>
                <ng-template ngbNavContent></ng-template>
            </li>
            <li ngbNavItem>
                <a ngbNavLink (click)='scroll("jobs")'><span class="underline nav-text"> {{"Header.Item2" | translate}}</span></a>
                <ng-template ngbNavContent></ng-template>
            </li>
            <li ngbNavItem>
                <a ngbNavLink (click)='scroll("skills")'><span class="underline nav-text"> {{"Header.Item5" | translate}}</span></a>
                <ng-template ngbNavContent></ng-template>
            </li>
            <li ngbNavItem>
                <a ngbNavLink (click)='scroll("proyects")'><span class="underline nav-text"> {{"Header.Item3" | translate}}</span></a>
                <ng-template ngbNavContent></ng-template>
            </li>
            <li ngbNavItem>
                <a ngbNavLink (click)='scroll("contact")'><span class="underline nav-text"> {{"Header.Item4" | translate}}</span></a>
                <ng-template ngbNavContent></ng-template>
            </li>
            <li>
                <div ngbDropdown class="d-inline-block">
                    <button type="button" class="language-container language-toggle" id="languageDropdown" ngbDropdownToggle attr.aria-label="{{'Header.LanguageLabel' | translate}}">
                        <span class="flag-text">{{languageFormControl.value === 'de' ? 'DE' : 'EN'}}</span>
                        <svg class='arrow-language' xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" aria-hidden="true"><path d="M0 7.33l2.829-2.83 9.175 9.339 9.167-9.339 2.829 2.83-11.996 12.17z"/></svg>
                    </button>
                    <div ngbDropdownMenu aria-labelledby="languageDropdown">
                        <button type="button" (click)='changeLanguage("de")' class="language-container language-container-selector" [class.active]='languageFormControl.value === "de"'>
                            <span class="flag-text">Deutsch</span>
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="arrow-active" viewBox="0 0 16 16" aria-hidden="true">
                                <path d="M13.854 3.646a.5.5 0 0 1 0 .708l-7 7a.5.5 0 0 1-.708 0l-3.5-3.5a.5.5 0 1 1 .708-.708L6.5 10.293l6.646-6.647a.5.5 0 0 1 .708 0z"/>
                            </svg>
                        </button>
                        <button type="button" (click)='changeLanguage("en")' class="language-container language-container-selector" [class.active]='languageFormControl.value === "en"'>
                            <span class="flag-text">English</span>
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="arrow-active" viewBox="0 0 16 16" aria-hidden="true">
                                <path d="M13.854 3.646a.5.5 0 0 1 0 .708l-7 7a.5.5 0 0 1-.708 0l-3.5-3.5a.5.5 0 1 1 .708-.708L6.5 10.293l6.646-6.647a.5.5 0 0 1 .708 0z"/>
                            </svg>
                        </button>
                    </div>
                </div>
            </li>
        </ul>
        <div class="menu-wrapper">
            <div role="button" tabindex="0" attr.aria-label="{{'Header.MenuLabel' | translate}}" [attr.aria-expanded]="responsiveMenuVisible" [class.animate]='responsiveMenuVisible' (click)='responsiveMenuVisible = !responsiveMenuVisible' (keyup.enter)='responsiveMenuVisible = !responsiveMenuVisible' class="hamburger-menu"></div>
        </div>
        <div class="menu-responsive" [ngStyle]="{'pointer-events': !responsiveMenuVisible ? 'none' : '' }">
            <aside [class.aside-show]='responsiveMenuVisible' [class.nav-shadow]='this.pageYPosition>0' class="on-top">
                <nav>
                    <ol>
                        <li>
                            <a (click)='scroll("about")'>
                                {{"Header.Item1" | translate}}
                            </a>
                        </li>
                        <li>
                            <a (click)='scroll("jobs")'>
                                {{"Header.Item2" | translate}}
                            </a>
                        </li>
                        <li>
                            <a (click)='scroll("skills")'>
                                {{"Header.Item5" | translate}}
                            </a>
                        </li>
                        <li>
                            <a (click)='scroll("proyects")'>
                                {{"Header.Item3" | translate}}
                            </a>
                        </li>
                        <li>
                            <a (click)='scroll("contact")'>
                                {{"Header.Item4" | translate}}
                            </a>
                        </li>
                        <li>
                            <div class="language-container">
                                <button type="button" (click)='changeLanguage("de")' class="language-container language-container-selector" [class.active]='languageFormControl.value === "de"'>
                                    <span class="flag-text">Deutsch</span>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="arrow-active" viewBox="0 0 16 16" aria-hidden="true">
                                        <path d="M13.854 3.646a.5.5 0 0 1 0 .708l-7 7a.5.5 0 0 1-.708 0l-3.5-3.5a.5.5 0 1 1 .708-.708L6.5 10.293l6.646-6.647a.5.5 0 0 1 .708 0z"/>
                                    </svg>
                                </button>
                                <button type="button" (click)='changeLanguage("en")' class="language-container language-container-selector" [class.active]='languageFormControl.value === "en"'>
                                    <span class="flag-text">English</span>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="arrow-active" viewBox="0 0 16 16" aria-hidden="true">
                                        <path d="M13.854 3.646a.5.5 0 0 1 0 .708l-7 7a.5.5 0 0 1-.708 0l-3.5-3.5a.5.5 0 1 1 .708-.708L6.5 10.293l6.646-6.647a.5.5 0 0 1 .708 0z"/>
                                    </svg>
                                </button>
                            </div>
                        </li>
                    </ol>
                </nav>
            </aside>
        </div>
    </div>
</nav>
